var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 28,
    viewBox: "0 0 20 28",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99984 0.666687C4.83984 0.666687 0.666504 4.84002 0.666504 10C0.666504 17 9.99984 27.3334 9.99984 27.3334C9.99984 27.3334 19.3332 17 19.3332 10C19.3332 4.84002 15.1598 0.666687 9.99984 0.666687ZM3.33317 10C3.33317 6.32002 6.31984 3.33335 9.99984 3.33335C13.6798 3.33335 16.6665 6.32002 16.6665 10C16.6665 13.84 12.8265 19.5867 9.99984 23.1734C7.2265 19.6134 3.33317 13.8 3.33317 10ZM6.6665 10C6.6665 8.15907 8.15889 6.66669 9.99984 6.66669C11.1907 6.66669 12.2911 7.30202 12.8866 8.33335C13.482 9.36469 13.482 10.6354 12.8866 11.6667C12.2911 12.698 11.1907 13.3334 9.99984 13.3334C8.15889 13.3334 6.6665 11.841 6.6665 10Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.07de2675614c0fa04fcc6c9579e0e32d.svg";
export { ForwardRef as ReactComponent };